import React from 'react'
import ProductMain from '../components/Product/ProductMain'
import Header from '../components/Shared/Header'
import Footer from '../components/Shared/Footer'

function Product() {
  return (
 <>
    <div>
    <Header />
        <ProductMain />
        <Footer />
    </div>
 </>
  )
}

export default Product
